<script>
	import { SHIP } from './constants/ASCII'
	import { fly } from 'svelte/transition'
	import Copy from './icons/Copy.svelte';
	import Npm from './icons/Npm.svelte';
	import Github from './icons/Github.svelte';

	const COMMAND = 'npm install -g battleship-rocks'
	function copy() {
		const el = document.querySelector('#hidden')
		const textArea  = document.createElement('textarea')
		textArea.value = COMMAND
		el.append(textArea)
		textArea.select()
		document.execCommand('copy')
		el.removeChild(textArea)
		notify()
	}

	let notifying = false
	let timeout = null
	function notify() {
		if(!notifying) toggleNotify()
		else clearTimeout(timeout)
		timeout = setTimeout(toggleNotify, 2000)
	}
	function toggleNotify() { notifying = !notifying }
</script>

<style>
	main {
		width: 100vw;
		height: 100%;
		color: var(--text-color);
		background: var(--bg-color);
		user-select: none;
	}
	section {
		flex-grow: 1;
	}
	footer {
		display: flex;
		flex-direction: column;
		margin-bottom: 10px;
	}
	.logo { 
		margin-bottom: 16%; 
		font-size: 0.9rem;
		font-weight: 100;
	}
	.name {
		font-size: 28px;
		margin-bottom: 8%; 
	}
	.cmd {
		padding: 12px 24px;
		background: #001a24;
		user-select: all;
		box-shadow: rgb(0, 20, 28) 3px 3px 6px 0px inset, rgb(0, 26, 36) -3px -3px 6px 1px inset;
		align-items: center;
		margin-bottom: 32px;
	}
	.cmd-text { margin-right: 8px; }
	#hidden { width: 0px; height: 0px; overflow:hidden; }
	#copy-button { fill: var(--text-color); }
	#copy-button:hover { fill: var(--accent-color); }

	.icons { margin-bottom: 12px; }
	.hi { font-size: 13px; }

	.notif {
		position: fixed;
		top: 20px;
		background: rgba(0,0,0,0.8);
		border-radius: 8px;
		padding: 10px 20px;
		font-weight: 100;
	}
</style>

<main class='f f-col cc'>
	<section class='f f-col cc'>
		<pre class='logo'>
			{SHIP}
		</pre>
		<span class='name'>
			battleship<strong class='accent'>.rocks</strong>
		</span>
		<div class='cmd f'>
			<span class='cmd-text'>
				{COMMAND}
			</span>
			<div 
				on:click={copy} 
				class='hoverable hover-accent f cc'
				id='copy-button'
			>
				<Copy size='16'/>
			</div>
		</div>
		<div class='icons f fw al-c ju-even'>
			<a class='icon' rel="noopener noreferrer" aria-label="NPM" href='https://npmjs.com/package/battleship-rocks' target='_blank'>
				<Npm size={32} fill='white'/>
			</a>
			<a class='icon' rel="noopener noreferrer" aria-label="Github repository" href='https://github.com/batuhandirek/battleship-rocks-client' target='_blank'>
				<Github size={32} fill='white'/>
			</a>
		</div>
	</section>
	<footer class='f cc'>
		<span class='hi'>
			Made with 🍺 by 
			<a class='accent' rel="noopener noreferrer" aria-label="Github profile" href='https://github.com/batuhandirek' target='_blank'>
				batuhandirek
			</a>
		</span>
	</footer>
	<div id='hidden'></div>
	{#if notifying}
		<div 
			in:fly={{duration: 200, y: 10}}
			out:fly={{duration: 200, y: 10}}
			class='notif'
		> Copied! </div>
	{/if}
</main>

